import React from "react";
import { Elements } from "react-stripe-elements";

import InjectedCheckoutForm from "./CheckoutForm";

type Props = {
  onClose: () => mixed,
  onSuccess: () => mixed
};

const StripeCheckout = ({ onClose, onSuccess }: Props) => (
  <Elements>
    <InjectedCheckoutForm onClose={onClose} onSuccess={onSuccess} />
  </Elements>
);

export default StripeCheckout;



// WEBPACK FOOTER //
// ./src/components/Stripe/StripeCheckout.jsx